module.exports = __webpack_public_path__ + "img/2.e58cc6a0.jpg";